export const autoResizeTextArea = (textarea: HTMLTextAreaElement) => {
    if (!textarea) return;

    // Reset height temporarily to get the correct scrollHeight
    textarea.style.height = '0px';

    // Set to scrollHeight + a small buffer to avoid scrollbar flicker
    const scrollHeight = textarea.scrollHeight;

    // Set the height to the scrollHeight
    textarea.style.height = `${scrollHeight}px`;
};
